import React from 'react';
import { withRouter } from 'react-router';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading"></div>
    </div>
  );
};

export default withRouter(Loading);
